import {observer} from 'mobx-react';
import CompanyDocumentUploadState from '../state/CompanyDocumentUploadState';
import {Input, Panel, FormLayout, LabelHelper, FormError, ObjectSelect2, Select2, Display, UploadFiles} from 'shared/components';
import {ModalButtons} from 'shared/components/modals';
import {t, withState} from 'shared/core';

const CompanyDocumentUpload = observer(({uiState}) => {
  const {companyDocument, companyDocuments, recipientOptions, errors, sortedFolders} = uiState;

  return (
    <div>
      <Display backPath='/documents'/>
      <div className='Container'>
        <Panel>
          <FormLayout>
            <Input value={companyDocument.name}
              label='company_settings.documents.Company Document Name'
              errorMessage={errors.name}
              onChange={(e) => companyDocument.merge({name: e.target.value})} />
            {companyDocument.documentType === 'static_document' &&
              <Select2
                label='company_settings.documents.Upload to Folder on Completion'
                allowClear
                value={companyDocument.folderId}
                onChange={(e) => companyDocument.merge({folderId: e.target.value || null})}>
                {sortedFolders.map((folder) =>
                  <option key={folder.id} value={folder.id}>{folder.name}</option>
                )}
              </Select2>
            }
            {companyDocument.documentType === 'static_document' &&
              <ObjectSelect2
                value={companyDocument.notificationRecipients}
                onAdd={recipient => companyDocument.addRecipient(recipient)}
                onRemove={recipient => companyDocument.removeRecipient(recipient)}
                items={recipientOptions}
                label='company_settings.documents.Notify on Completion'
                placeholder='company_settings.documents.e.g., Manager'
                by='value'
                multiple
                searchable={true}
              />
            }
            <div className='clearfix'>
              <LabelHelper label={t('company_settings.documents.Upload your document')}/>
              <UploadFiles
                defaultFiles={companyDocuments}
                onChange={(files) => uiState.updateFile(files)}
                onUploadStarted={() => uiState.onUploadStarted()}
                onUploadFinished={() => uiState.onUploadFinished()}
                errorMessage={errors.originalFile}
                isUploading={uiState.isUploading}
                maxFiles={1}
                accept={uiState.acceptedMimeTypes}
                modelType='company_documents/base'
              />
              <FormError messsage={errors.base} />
            </div>
            <ModalButtons
              onSave={() => uiState.saveCompanyDocument()}
              saveEnabled={uiState.canSaveDocument}
              onCancel={() => uiState.goBack()}
            />
          </FormLayout>
        </Panel>
      </div>
    </div>
  );
});

export default withState(CompanyDocumentUpload, CompanyDocumentUploadState);
